/**
 * Data Filter Functions
 * Utility functions for filtering and sorting data
 */

/**
 * Filter and sort client data based on filter string
 * @param {Array} clientData - Array of client data
 * @param {string} filter - Filter string
 * @returns {Array} Filtered and sorted client data
 */
export const filterClientData = (clientData, filter) => {
  return clientData
    .filter(
      (client) =>
        client.client_name.toLowerCase().includes(filter.toLowerCase()) ||
        client.projects.some((project) =>
          project.project_name.toLowerCase().includes(filter.toLowerCase())
        )
    )
    .sort((a, b) => a.client_name.localeCompare(b.client_name));
};

/**
 * Filter and sort tag items based on query string
 * @param {Array} tagOptions - Array of tag options
 * @param {string} tagQuery - Query string
 * @returns {Array} Filtered and sorted tag items
 */
export const filterTagItems = (tagOptions, tagQuery) => {
  const seen = new Set();
  return tagOptions
    .filter((item) => {
      if (!item.tag_name) return false;
      if (seen.has(item.tag_name.toLowerCase())) return false;
      seen.add(item.tag_name.toLowerCase());
      return item.tag_name.toLowerCase().includes(tagQuery.toLowerCase());
    })
    .sort((a, b) => a.tag_name.localeCompare(b.tag_name));
};
